export default __webpack_public_path__ + "static/media/6B1_19766_HIRES.dcffe06f.png";